/* eslint-disable */ 

import React, { useState, useEffect, useContext } from "react"
import { useStaticQuery, graphql, navigate } from "gatsby"
import { Context } from "../Context"

import ApiMessage from "../post/ApiMessage"  

import CodeExample from "./CodeExample"
import ResponseExample from "./ResponseExample"

import ObjectsTable from "./ObjectsTable"

import objectsTableStyles from "./ObjectsTable.module.css"

import ApiStyles from "./index.module.css"

export default function API({dataSource}) {

    const data = useStaticQuery(graphql`
        query {         
            allApiJson{
                edges {
                  node {
                    name
                    content {
                      title
                      menu_title
                      method
                      version
                      name
                      description
                      message{
                          type
                          text
                      }
                      request_description
                      code_title
                      code {
                        name
                        example
                        example_extended{
                            title
                            request{
                                title
                                code
                            }
                            response{
                                title
                                code
                            }    
                            message                            
                        }
                      }
                      method_arguments{
                        order
                        name
                        data_type
                        short_description
                        required
                        description                          
                      }          
                      return_object{
                          name
                          order
                          description
                          short_description
                      }                                
                      response
                      response_description
                      input_objects{
                          name
                          description
                          short_description  
                          data_type     
                          required                   
                          attributes{
                            name
                            short_description
                            order
                            data_type
                            required
                            description                         
                            attributes{
                                name
                                order
                                required
                                data_type
                                short_description
                                description
                                message{
                                    type
                                    text
                                }                                  
                                attributes{
                                    name
                                    order
                                    required
                                    data_type
                                    short_description
                                    description                                 
                                    attributes{
                                        name
                                        order
                                        required
                                        data_type
                                        short_description
                                        description                                        
                                    }                                         
                                }                                  
                            }                              
                          }
                      }
                      output_objects{
                          name
                          description
                          data_type             
                          short_description
                          example                           
                          attributes{
                            name
                            order
                            data_type
                            short_description
                            description                                
                            attributes{
                                name
                                order
                                data_type
                                short_description
                                description                                                                     
                            }                               
                          }
                      }                     
                    }
                  }
                }
              }                         
        }
    `)    

    const [context] = useContext(Context)

    let submenu_items = false

    const [ defaultLanguage, setDefaultLanguage ] = useState('cURL')

    const handleChange = (selectedLanguage) => {
        setDefaultLanguage(selectedLanguage)
    }   
    

    // flatten the Tree for initial states
    // we must get initialState if from parametersState it was set before
    let initialState  = []
    
    if(dataSource){
        let nodeJSON = data.allApiJson.edges.filter( ({node}) => node.name === dataSource)[0] 
        let contentJSON = nodeJSON.node.content

        contentJSON.forEach(({ name, method_arguments, return_object, input_objects, output_objects}) => {

            let methodName = name

            // remove /<>
            if(methodName){
                let formatedMethodName = methodName.replace(/[^0-9a-zA-Z_-]/g, "")
                //console.log("formatedMethodName: ", formatedMethodName)
                methodName = formatedMethodName
            }            

            const flattenTree = (data, parent, tableName) => {
                data.forEach(({name, attributes}, index) => {
                    
                    //console.log(`${parent} : ${name}`)

                    // we add methodName one time only
                    const id = parent ? `${parent}--${name.toLowerCase().replace(/\s/g, '-')}__${tableName}` : `${methodName}___${name.toLowerCase().replace(/\s/g, '-')}__${tableName}`
                    

                    if(attributes){
                        flattenTree(attributes, id, tableName)
                    }
                    
                    initialState.push({
                        name: name,
                        id: id,
                        open: index === 0 ? true : false // if this is 1st object in table we set it to open
                    })
                })
            }

            if(method_arguments){
                flattenTree(method_arguments, null, 'arguments')
            }  

            if(return_object){
                flattenTree(return_object, null, 'returns')
            }                                

            if(input_objects){
                flattenTree(input_objects, null, 'attributes')
            }

            if(output_objects){
                flattenTree(output_objects, null, 'attributes')
            }                
    
        })          
    
    }

    // copy initial state to state tracker
    let parametersStateTracker = initialState
 
    const [parametersState, setParametersState] = useState(initialState)

    const [lastChildAction, setLastChildAction] = useState(null)

    const handleParametersStateChange = (action) => {

        //console.log("action: ", action)
                
        let { type, id } = action

        switch (type) {
            case 'toggle':      
                // toggle 1 element
                //console.log("toggle")
                parametersStateTracker = parametersStateTracker.map(item => (item.id === id ? { ...item, open: !item.open } : item))   
                
                break 
            case 'setOpen':
                // set to true elements that are in the list of open elements
                //console.log("setOpen")
                parametersStateTracker = parametersStateTracker.map(item => (id.includes(item.id) ? { ...item, open: true } : item)) 

                break
            case 'setClose':   
                // set to false elements that are in the list of open elements
                //console.log("setClose")
                parametersStateTracker = parametersStateTracker.map(item => (id.includes(item.id) ? { ...item, open: false } : item))     

                break 
            case 'openBranch':
                
                //console.log("openBranch called and ID: ", id)

                setLastChildAction(action)

                // parse start_encode2___query__attributes--format__attributes--output__attributes
                // convert to array of ids

                const parseBranch = id =>{
                    let branchIds = []
                    // remove prefix
                    let ids = id.split('___')[1].split('--')
                    branchIds.push(id)
            
                    let temp = id
            
                    for(let i = ids.length-1; i > 0; i--){
                        temp = temp.replace(`--${ids[i]}`,'')
                        branchIds.push(temp)                        
                    }
                    
                    return branchIds
                }                   
                        
                
                let branchIds = parseBranch(id)

                //
                // update state to open the branch leading to target element
                //
                 
                parametersStateTracker.map(item => {
                    //console.log("item.id: ", item.id);

                    // mast format item id
                    let formatedItemId = item.id.replace(/[^0-9a-zA-Z_-]/g, "")

                    // if(document.querySelector(`#${item.id} > button`) && document.querySelector(`#${item.id} > button`).getAttribute("aria-expanded") === "true"){
                    if(document.querySelector(`#${formatedItemId} > button`) && document.querySelector(`#${formatedItemId} > button`).getAttribute("aria-expanded") === "true"){                        
                        item.open = true
                    } else{
                        item.open = false
                    }                        
                    return item
                })

                // set all branch ids to open
                parametersStateTracker = parametersStateTracker.map(item => (branchIds.includes(item.id) ? { ...item, open: true } : item)) 
               
                
                // if branch is not opened
                setParametersState(parametersStateTracker)
                // we should also remember the action and send it back to child, so it recognize it and scrolls down



                break                       
            default:
                //console.log("Action Type: ", type)
                break
        }

    }


    let targetFromHref = null
    if(typeof window !== `undefined` && window.location.href){
        targetFromHref = window.location.href
        targetFromHref = targetFromHref.split('#')
        if(targetFromHref[1]){
            targetFromHref = "#"+targetFromHref[1]
        } else{
            targetFromHref = null
        }
    }    

    //console.log("targetFromHref: ", targetFromHref)

    useEffect(() => {
        //console.log("____________Update based on targetFromHref_____________")
        // only this is a link for attribute 
        // if(href && href!=='#' && href[0]==='#' && href.includes("___")){
        if(targetFromHref && targetFromHref!=='#' && targetFromHref[0]==='#' && targetFromHref.includes("___")){

            // remove # from href to get actual ID
            let targetId = targetFromHref.substring(1, targetFromHref.length)            

            // open DOM here
            const parseBranch = id =>{
                let branchIds = []
                // remove prefix
                let ids = id.split('___')[1].split('--')
                branchIds.push(id)

                let temp = id

                for(let i = ids.length-1; i > 0; i--){
                    temp = temp.replace(`--${ids[i]}`,'')
                    branchIds.push(temp)                        
                }
                
                return branchIds
            }

            let id = targetId
            
            //console.log("targetFromHref: ", targetFromHref)
            // query.new_lvl_2
            // 0: "dummy___query_lvl_1__attributes--query.new_lvl_2__attributes"
            // 1: "dummy___query_lvl_1__attributes"            

            let branchIds = parseBranch(id)  

            //console.log("branchIds: ",branchIds)

            branchIds.forEach(id => {
                // check if element already existts
                if(document.querySelector(`#${id} > button`)){
                    document.querySelector(`#${id} > button`).setAttribute("class", `${objectsTableStyles.item} ${objectsTableStyles.active}`)  
                    document.querySelector(`#${id} > button`).setAttribute("aria-expanded", "true")
                                    
                    document.querySelector(`#${id} > div`).setAttribute("class", `${objectsTableStyles.body} ${objectsTableStyles.active}`) 
                }
            })                 

            // scroll here 
            let element = document.getElementById(id)
            if(element){

                // get #mobile-mode and see if it is visible
                let offset = 1;

                let mobileMode = document.getElementById('mobile-mode')
                if(mobileMode){
                    if(mobileMode.offsetWidth > 0 || mobileMode.offsetHeight > 0){
                        offset = 70
                    }
                }
                
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = element.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                }); 


            }                            

            handleParametersStateChange({
                type:'openBranch',
                id:id 
            })  
        }else if(targetFromHref!=='#'){
            // console.log("targetFromHref: ", targetFromHref)

            // we get here if targetFromHref is not id for object
            
            if(targetFromHref === null){
                navigate(targetFromHref)
            } else{
                // remove # from href to get actual ID
                let targetId = targetFromHref.substring(1, targetFromHref.length)  
                // scroll here 
                let element = document.getElementById(targetId)
                if(element && typeof window !== `undefined`){
                    // handle smooth scrolli                    
                    // handle http://localhost:8000/api-reference/transcoding/#supported-output-formats
                    // see https://stackoverflow.com/a/49924496/6261255
                    //console.log("EXTRA SCROLLING........ based on targetFromHref: ", targetFromHref)
                    // element.scrollIntoView({behavior: "smooth"})  

                    // change offset based on mobile mode or not
                    
                    // get #mobile-mode and see if it is visible
                    let offset = 1;

                    let mobileMode = document.getElementById('mobile-mode')
                    if(mobileMode){
                        if(mobileMode.offsetWidth > 0 || mobileMode.offsetHeight > 0){
                            offset = 50
                        }
                    }
                    
                    const bodyRect = document.body.getBoundingClientRect().top;
                    const elementRect = element.getBoundingClientRect().top;
                    const elementPosition = elementRect - bodyRect;
                    const offsetPosition = elementPosition - offset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });                    
                }             
            }
            
            //navigate(targetFromHref)
            
        }
    },[targetFromHref])


    useEffect(() => {
        //console.log("CONTEXT UPDATED IN INDEX API")


        //console.log("set action to openBranchFromSearch")
        setLastChildAction({
            type:'openBranchFromSearch',
            id: context    
        })

    }, [context])

    useEffect(() => {

        //console.log("NOW STATE UPDATED")

        // sync tracker to the state to avoid trecker set to initial data
        parametersStateTracker = parametersState

        // get id of target elent and scroll to it                                         
        //console.log(lastChildAction)
        if(lastChildAction && lastChildAction.type === "openBranch"){
            // get id of target elent and scroll to it                                 
            let element = document.getElementById(lastChildAction.id)
            if(element){
                //console.log("SCROLLING... parametersState...")

                // get #mobile-mode and see if it is visible
                let offset = 1;

                let mobileMode = document.getElementById('mobile-mode')
                if(mobileMode){
                    if(mobileMode.offsetWidth > 0 || mobileMode.offsetHeight > 0){
                        offset = 70
                    }
                }
                
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = element.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                }); 

                //element.scrollIntoView({behavior: "smooth"})  
            }
             
        }                   

    
    
    }, [parametersState])  


    if(dataSource){

        // console.log("RENDER ALL COMPONENTS")

        // console.log("parametersStateTracker")
        // console.log(parametersStateTracker[82])

        // console.log("parametersState")
        // console.log(parametersState[82])


        let nodeJSON = data.allApiJson.edges.filter( ({node}) => node.name === dataSource)[0] 
        let contentJSON = nodeJSON.node.content
        // console.log("contentJSON: ", contentJSON)
        let sections = contentJSON.map(({
            title, description, method, version, name, message, code, code_title, request_description, method_arguments,
            return_object,
            input_objects, output_objects,
            response, response_description}) => {
            return {
                id: title.toLowerCase().split(' ').join('-'),
                title: title,
                method: method,
                version: version,
                name: name,
                description: description,
                message: message,
                code_title: code_title,
                code: code,
                requestDescription: request_description,
                arguments: method_arguments,
                return_object: return_object,
                input_objects: input_objects,
                output_objects: output_objects,
                response: response,
                response_description: response_description,                
            }
        })        

        submenu_items = sections.map( (item, index) => {

            // break down parametersState in segments and pass only related segments to components as props
            // parametersState
            // at this stage only keep array of states starting with item.name
  
            // let method = item.name
            // let filterdParametersStates = parametersState.filter(item => item.id.startsWith(method))

            // dataSource
            
            return (
                <section key={index} className={ApiStyles.container}>

                    <div>                       
                        <div>
                            <h2 id={item.id}>{item.title}</h2>        
                            <div className={ApiStyles.methodContainer}>
                                <div className={ApiStyles.method}>{item.method}</div>
                                <div className={ApiStyles.request}>&#47;{item.version}&#47;{item.name}</div>
                            </div>                                
                        </div>
                        <div></div>
                    </div>
                    <div>
                        <div>
                            <div dangerouslySetInnerHTML={ {__html: item.description} } />

                            {
                                item.message && (
                                    <ApiMessage type={item.message.type}>
                                        {item.message.text}
                                    </ApiMessage>  
                                )
                            } 

                            {/* {
                                item.arguments && 
                                    <ObjectsTable  title="Arguments" data={item.arguments} parametersState={parametersState} onChange={handleParametersStateChange}/>
                            } */}
                      

                            {/* {
                                item.arguments && 
                                    <ObjectsTable  title="Arguments" data={item.arguments} onButtonToggle={onButtonToggle}/>
                            }                                  */}

                            {
                                item.arguments && 
                                    <ObjectsTable methodName={item.name}  title="Arguments" parametersState={parametersState} data={item.arguments} onChange={handleParametersStateChange}/>
                            }      
                        
                            {
                                item.return_object && 
                                    <ObjectsTable methodName={item.name}  title="Returns" parametersState={parametersState} data={item.return_object} onChange={handleParametersStateChange}/>
                            }                        

                            {
                                item.input_objects &&                                 
                                    <div className={ApiStyles.objectsContainer}>
                                        <div className={ApiStyles.objectsTitle}>Input Objects Structure</div>
                                        <ObjectsTable methodName={item.name} title="Attributes" parametersState={parametersState} data={item.input_objects} onChange={handleParametersStateChange}/>
                                    </div>                                  
                            }

                            {
                                item.output_objects &&                                 
                                    <div className={ApiStyles.objectsContainer}>
                                        <div className={ApiStyles.objectsTitle}>Output Objects Structure</div>
                                        <ObjectsTable methodName={item.name} title="Attributes" parametersState={parametersState} data={item.output_objects} onChange={handleParametersStateChange}/>
                                    </div>                                  
                            }                        
                                                    
                        </div>
                        <div>
                            <div className={ApiStyles.codeContainer}>
                                {
                                    item.code &&
                                    <CodeExample 
                                        id={`codeExpl_${index}`} 
                                        title={item.code_title}
                                        codeList={item.code} 
                                        requestDescription = {item.requestDescription}
                                        defaultLanguage={defaultLanguage} 
                                        onChange={handleChange} 
                                    />                                      
                                }  
                                {
                                    item.response &&
                                    <ResponseExample 
                                        example={item.response}
                                        description={item.response_description}
                                    />                                        
                                }                  
                            </div>                         
                        </div>                  
                    </div>

                </section>
            )
        })         
    }      


    return (
        <>        
            {
                dataSource && submenu_items.length > 0 && submenu_items
            }                             
        </>

    )
}